"use client"
import React from 'react';
import Link from "next/link";

const CategoryResult = ({data}: { data: any }) => {


    const categories = data?.categories
    return (
        <div>
            <h4 className={"text-base"}>دسته بندی ها</h4>
            <div className={"flex flex-col gap-y-2 mt-2"}>
                {categories?.map((item: any, index: number) => (
                    <Link target={"_blank"} href={`/category/${item?.slug}`} key={index} className={"flex text-sm hover:text-orange-primary transition-all"}><span
                        className={"text-orange-primary ml-1"}>در دسته</span>{item?.title}</Link>
                ))}
            </div>
        </div>
    );
};

export default CategoryResult;